import React, { useId } from 'react';

// Vector artwork based on the supplied BigSix reference, shared by web and print.
const BrandLogo = ({ className = '' }) => {
  const id = useId().replace(/:/g, '');
  return <svg className={`brand-logo ${className}`} viewBox="0 0 430 120" role="img" aria-label="BigSix" xmlns="http://www.w3.org/2000/svg">
    <title>BigSix</title>
    <defs>
      <linearGradient id={`${id}-building`} x1="0" y1="1" x2="1" y2="0"><stop stopColor="#075178" /><stop offset=".5" stopColor="#087e98" /><stop offset="1" stopColor="#16b99e" /></linearGradient>
      <linearGradient id={`${id}-six`} x1="0" y1="1" x2="1" y2="0"><stop stopColor="#075178" /><stop offset=".55" stopColor="#119eaa" /><stop offset="1" stopColor="#24bda7" /></linearGradient>
    </defs>
    <g transform="translate(2 7)">
      <path d="M0 35 40 10 56 0 77 14 82 18 82 5 95 5 95 24 112 35 112 106H0Z" fill={`url(#${id}-building)`} />
      <path d="M41 9 0 75M56 0 0 88" fill="none" stroke="#fff" strokeWidth="3.5" />
      <path d="M73 12 32 68C21 86 34 104 53 104C71 104 85 88 81 71C78 57 68 49 56 47" fill="none" stroke="#fff" strokeWidth="17" />
      <path d="M73 12 32 68C21 86 34 104 53 104C71 104 85 88 81 71C78 57 68 49 56 47" fill="none" stroke={`url(#${id}-six)`} strokeWidth="11" />
      <circle cx="53" cy="77" r="16" fill="#fff" />
      <path d="m83 29 6 3v6l-6-2zm13 5 6 3v6l-6-2zM83 40l6 3v6l-6-2zm13 6 6 3v6l-6-2zM96 57l6 3v6l-6-2z" fill="#fff" />
    </g>
    <text x="137" y="94" fontFamily="Arial, Helvetica, sans-serif" fontSize="91" fontWeight="700" letterSpacing="-4" fill="var(--brand-ink, #35414e)">Big</text>
    <text x="281" y="94" fontFamily="Arial, Helvetica, sans-serif" fontSize="91" fontWeight="300" letterSpacing="-4" fill="var(--brand-teal, #11aaa5)">Six</text>
  </svg>;
};

export default BrandLogo;
